export enum NumberFilterCondition {
  GreaterThan = 'GREATER THAN',
  GreaterThanOrEqualTo = 'GREATER THAN OR EQUAL TO',
  LessThan = 'LESS THAN',
  LessThanOrEqualTo = 'LESS THAN OR EQUAL TO',
  IsEqualTo = 'IS EQUAL TO',
  IsNotEqualTo = 'IS NOT EQUAL TO',
  IsBetween = 'IS BETWEEN',
  IsNotBetween = 'IS NOT BETWEEN',
}

export enum CellFilterCondition {
  IsEmpty = 'IS EMPTY',
  IsNotEmpty = 'IS NOT EMPTY',
  IsEdited = 'IS Edited',
  EditedBefore = 'Edited Before',
  EditedOn = 'Edited On',
  LastEditedBy = 'LAST Edited By',
  // ContainsFiles = 'Contains Files',
}

export enum TextFilterCondition {
  TextContains = 'TEXT CONTAINS',
  TextDoesNotContains = 'TEXT DOES NOT CONTAINS',
  TextStartsWith = 'TEXT STARTS WITH',
  TextEndsWith = 'TEXT ENDS WITH',
  TextIsExactly = 'TEXT IS EXACTLY',

  TextIsValidURL = 'TEXT IS VALID URL',
  TextIsValidEmail = 'TEXT IS VALID EMAIL',
}

export enum DateFilterCondition {
  IsValid = 'IS VALID',
  DateIs = 'DATE IS',
  Before = 'BEFORE',
  OnOrBefore = 'ON OR BEFORE',
  After = 'AFTER',
  OnOrAfter = 'ON OR AFTER',
  IsBetween = 'IS DATE BETWEEN',
  IsNotBetween = 'IS DATE NOT BETWEEN',
}
export enum FilterValueMode {
  // NONE = 'NONE',
  Select = 'S', // In
  Deselect = 'D', // This mode will only be active when there is no value filter applied and user deselect a value in muliselect mode
}

// export interface FilterResult {
//   hasFilter: boolean;
//   // count: number,
//   rowIndexes: number[];
//   lastRow: number;
//   frozenFilteredRows: number;
// }

export enum FilterType {
  TextColor = 'TC',
  FillColor = 'FC',
  Condition = 'C',
  Value = 'V',
}

// #region value filter
export interface FilterValues {
  [value: string]: string; // lowercaseValue: Value with original case
}

export interface ValueFilter {
  // type: FilterType.Value;
  values: FilterValues;
  valueMode: FilterValueMode;
}
// #endregion

// #region condition filter
// export enum FilterConditionType {

//   Cell = 1,
//   Number = 2,
//   Text = 3,
//   Date = 4,
// }
export type FilterCondition =
  | CellFilterCondition
  | NumberFilterCondition
  | TextFilterCondition
  | DateFilterCondition;

// interface BasicFilterCondition {
//   type: FilterCondition;
//   // splitSpace?: boolean;
//   filterText: string;
// }

// // export const textlessFilterConditions: Array<FilterCondition> = [
// //   CellFilterCondition.IsEmpty,
// //   CellFilterCondition.IsNotEmpty,
// //   CellFilterCondition.ContainsFiles,
// //   CellFilterCondition.IsEdited,
// //   TextFilterCondition.TextIsValidURL,
// //   TextFilterCondition.TextIsValidEmail,
// //   DateFilterCondition.IsValid,
// // ];

// interface TextlessFilterCondition {
//   type:
//     | CellFilterCondition.IsEmpty
//     | CellFilterCondition.IsNotEmpty
//     | DateFilterCondition.IsValid
//     | TextFilterCondition.TextIsValidEmail
//     | TextFilterCondition.TextIsValidURL
//     | CellFilterCondition.ContainsFiles
//     | CellFilterCondition.IsEdited;
// }

// interface RangeFilterCondition {
//   type:
//     | NumberFilterCondition.IsBetween
//     | NumberFilterCondition.IsNotBetween
//     | DateFilterCondition.IsBetween
//     | DateFilterCondition.IsNotBetween;
//   start: string;
//   end: string;
// }

// export type ConditionFilter = {
//   type: FilterType.Condition;
// } & (BasicFilterCondition | RangeFilterCondition | EmptyCondition);
export type ConditionFilter = {
  type: FilterCondition;
  firstText?: string;
  secondText?: string;
};
// | BasicFilterCondition
// | RangeFilterCondition
// // | ValidFilterCondition
// | TextlessFilterCondition;
// #endregion

// #region color filter
// export interface ColorFilter {
//   // type: FilterType.TextColor | FilterType.FillColor;
//   color: string;
// }
// #endregion

// export type Filter = ConditionFilter | ColorFilter | ValueFilter;
export type Filter = {
  condition?: ConditionFilter;
  textColor?: string;
  value?: ValueFilter;
  fillColor?: string;
};
// export interface Filter {
//   by: FilterType;
//   condition?: FilterCondition;
//   // values: FilterValues;
//   // valueMode: FilterValueMode;
//   text?: string;
//   firstText?: string;
//   secondText?: string;
// }

export interface ColFilters {
  [colId: string]: Filter;
}

export interface FilterViews {
  [id: string]: ColFilters;
}

export interface FilterSettings {
  advanceTextSearch?: boolean;
  startRow?: number;
  endRow?: number;
}
